import { motion } from 'framer-motion';

interface Props {
    onClick: () => void
    title: string
    id: number
    idActual?: number
}
export function MenuItem({ onClick, id, idActual, title }: Props) {
    const isActive = id === idActual
    return (
        <button
            className={`relative flex-1 min-w-[7.5rem] px-6 py-4 flex items-center justify-center font-roboto font-bold text-[0.625rem] lg:text-xs uppercase no-underline cursor-pointer border-none transition-colors duration-300 ${isActive
                ? 'text-primary dark:text-secondary-light bg-surface-alt/50 dark:bg-surface-dark-alt'
                : 'text-primary/70 dark:text-white/60 bg-secondary dark:bg-primary-dark hover:bg-secondary-dark dark:hover:bg-primary-light hover:text-primary dark:hover:text-white'
                }`}
            onClick={onClick}
        >
            {isActive && (
                <motion.div
                    layoutId="activeTab"
                    className="absolute bottom-0 left-0 right-0 h-1 bg-primary-dark dark:bg-secondary"
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                />
            )}
            <span className="relative z-10">{title}</span>
        </button>
    )
}